import { useEffect } from "react";
import { updateDoc, doc, increment } from "firebase/firestore";
import { db } from "../lib/db/config";
// utils
import uploadSaga from "../lib/db/uploadSaga";
// styles
import "./styles/pixel-stars.css";

export default function Home() {

  useEffect(() => {
    updateDoc(doc(db, "app", "infos"), {
      visitCount: increment(1)
    });
  }, []);

  async function handleSagaSubmit(e) {
    e.preventDefault();

    document.body.style.pointerEvents = "none";

    const res = await uploadSaga({
      saga: e.target.saga.value
    });

    if (!res.success) {
      await updateDoc(doc(db, "app", "infos"), {
        errorCount: increment(1)
      });

      console.log(res.error);

      document.body.style.pointerEvents = "all";
      alert("Error uploading saga. Please try again");

      return;
    }

    document.getElementById("saga_form").reset();
    document.body.style.pointerEvents = "all";
  
    alert("Saga posted successfully.");
  }

  return (
    <div className="page home_page">
      <header>
        <div className="header_inner">
          <div className="pixel_stars">
            <div className="stars_1"></div>
            <div className="stars_2"></div>
          </div>

          <div className="container">
            <div className="logo">
              <img src={require("../assets/images/logo.png")} alt="RUET" />
            </div>
  
            <h1>Write your saga / story anonymously</h1>
            
            <form className="default" id="saga_form" onSubmit={handleSagaSubmit}>
              <div className="inputs">
                <div className="input_container">
                  <textarea id="saga" name="saga" placeholder="Write your saga here..."></textarea>
                </div>
              </div>

              <div className="actions">
                <button className="primary_btn round w_100">Post Saga</button>
              </div>
            </form>
          </div>
        </div>
      </header>
    </div>
  )
}
